import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ClockIcon, SmartphoneIcon, BatteryWarningIcon, MoonIcon } from 'lucide-react';
export function AgitationSection() {
  const loops = [{
    icon: <SmartphoneIcon className="w-8 h-8 text-amber" data-id="element-17" />,
    text: 'Te despertás y antes de sentir tu propio cuerpo, ya estás en el celular. Ya estás en el mundo de los demás. Ya saliste de vos.'
  }, {
    icon: <ClockIcon className="w-8 h-8 text-amber" data-id="element-18" />,
    text: 'El día arranca en modo reactivo. Apagás incendios. Respondés. Cumplís. A veces entrenás. A veces no. Comés lo que hay, no lo que necesitás.'
  }, {
    icon: <BatteryWarningIcon className="w-8 h-8 text-amber" data-id="element-19" />,
    text: 'Llegás a casa y querés estar presente, pero llegás vacío. Le das lo que sobra a los que más querés.'
  }, {
    icon: <MoonIcon className="w-8 h-8 text-amber" data-id="element-20" />,
    text: "Y a la noche, en vez de cerrar el día, lo prolongás. Pantalla hasta tarde. Ese momento de 'descanso' que en realidad es más estimulación."
  }];
  return <section id="agitation" className="py-14 md:py-32 bg-charcoal-dark border-y border-charcoal-light" data-id="element-21">
      <div className="max-w-4xl mx-auto px-6" data-id="element-22">
        <FadeIn data-id="element-23">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-offwhite mb-4 md:mb-6 text-center" data-id="element-24">
            Pensemos en cómo se ve eso en un día normal.
          </h2>
          <p className="text-center text-offwhite-dim mb-10 md:mb-16 text-lg" data-id="element-25">
            Y así, día tras día, el loop se repite. No porque seas débil.
          </p>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8 mb-10 md:mb-16" data-id="element-26">
          {loops.map((loop, index) => <FadeIn key={index} delay={index * 0.1} direction="up" className="bg-charcoal p-8 rounded-sm border border-charcoal-light hover:border-sand/30 transition-colors" data-id="element-27">
              <div className="mb-4 md:mb-6 bg-charcoal-dark w-14 h-14 md:w-16 md:h-16 rounded-full flex items-center justify-center border border-charcoal-light" data-id="element-28">
                {loop.icon}
              </div>
              <p className="text-offwhite-dim leading-relaxed" data-id="element-29">{loop.text}</p>
            </FadeIn>)}
        </div>

        <div className="max-w-3xl mx-auto text-center space-y-8" data-id="element-30">
          <FadeIn delay={0.4} data-id="element-31">
            <h3 className="text-3xl font-heading font-bold text-sand" data-id="element-32">
              Porque perdiste coherencia.
            </h3>
            <p className="mt-6 text-lg text-offwhite-dim" data-id="element-33">
              Coherencia no es perfección. No es tenerlo todo bajo control.
            </p>
            <p className="mt-4 text-xl font-medium text-offwhite" data-id="element-34">
              Coherencia es cuando lo que pensás, lo que sentís y lo que hacés
              van en la misma dirección.
            </p>
          </FadeIn>

          <FadeIn delay={0.5} data-id="element-35">
            <p className="text-lg text-offwhite-dim" data-id="element-36">
              Cuando eso se rompe, el esfuerzo no alcanza. Podés hacer todo
              "bien" y aun así sentirte fuera de lugar. Fuera de vos. Esa
              sensación de{' '}
              <em className="text-amber" data-id="element-37">"algo no está bien pero no sé qué"</em>
              … eso es desalineación.
            </p>
          </FadeIn>

          <FadeIn delay={0.6} data-id="element-38">
            <div className="inline-block mt-8 p-6 border-l-4 border-sand bg-charcoal text-left" data-id="element-39">
              <p className="text-xl font-heading font-bold text-offwhite" data-id="element-40">
                Y tiene solución.
              </p>
              <p className="mt-2 text-sand font-medium" data-id="element-41">
                No en meses. En 7 días podés sentir el primer movimiento de
                vuelta.
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}